import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ContractStatus } from '../../../../core/interfaces/contract-interfaces';

@Component({
  selector: 'app-contract-status',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './contract-status.component.html',
  styleUrl: './contract-status.component.css'
})
export class ContractStatusComponent {
  ContractStatus = ContractStatus;

  @Input() status: boolean | null = null;
  @Input() statusOkColor: string = '#A9BE92';

  @Input() statusEnum: ContractStatus | null = null;
}
